import styled from 'styled-components';
import {
  infoColor,
  grayColor,
} from "~/components/layout/Variables";

export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 2rem auto 3.5rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const Card = styled.div`
  background-color: white;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  margin: 1rem auto;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  max-width: 762px;
  box-shadow: 0px 6px 12px #00000066;

  @media (max-width: 700px) {
    margin: 1rem 0.8rem 0 0.8rem;
    height: auto;
    min-height: 85vh;
  }

  @media (max-width: 700px) and (min-height: 795px) {
    min-height: 90vh;
  }

  @media (min-width: 768px) {
    border-radius: 0.5rem;
  }
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: "0.3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const CardHeaderTotal = {
  backgroundColor: "#777",
  color: "#fff",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: "0.3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};


export const CenterHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  padding-top: 0.1rem;

  @media (max-width: 700px) {
    text-align: center;
  }

  @media (max-width: 450px) {
    font-size: 0.9rem;
  }
`;

export const CenterItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  overflow: hidden;
`;

export const ContainerCard = styled.div`
  margin-top: 0rem;
`;

export const DesktopDetails = styled.div`
  @media (min-width: 500px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
`;

export const DesktopGridDetails = styled.div`
  @media (min-width: 500px) {
    display: flex;
    justify-content: space-between;
    margin-right: 2rem;
  }
`;

export const FlexContainer = styled.div`
  flex: 1;
`

export const IconInformationBlue = {
  width: 20,
  height: 20,
  marginLeft: 5,
};

export const LeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const LeftItemQuantityTotal = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  color: #fff;

  @media (max-width: 700px) {
    text-align: center;
    white-space: nowrap;
  }
  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const MainContainer = styled.div`
  margin: 2rem 0rem;

  @media(min-width: 768px) {
    margin: 2rem 0rem;
  }

  @media (max-width: 450px) {
    margin: 2rem 0rem;
  }
`;

export const PrintIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 6%;
    height: 6%;
  }
`;

export const Product = styled.span`
  font-size: 1.1rem;
  color: ${() => infoColor};
  display: flex;
  justify-content: left;
`;

export const RightItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;

  @media (max-width: 700px) {
    text-align: right;
  }
  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const RightItemQuantityTotal = styled(SubTitle)`
  width: 100%;
  text-align: right;
  color: #fff;

  @media (max-width: 700px) {
    text-align: right;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};
  display: flex;
  justify-content: space-between;

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 0 0;
    display: flex;
    align-items: center;
  }
`;

export const TitleCard = styled.h4`
  color: #487cf5;
  font-size: 1rem;
  font-weight: 600;
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin: 0 1rem 1rem -3rem;
    }
  }

`;

export const TypeOrderContainer = styled.div`
  display: flex;
`